import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {MobileHeaderComponent} from './mobile-header.component';

@NgModule({
  imports: [CommonModule, RouterModule],
  declarations: [MobileHeaderComponent],
  exports: [MobileHeaderComponent],
})
export class MobileHeaderModule {}



// WEBPACK FOOTER //
// ./src/app/shared/ui/mobile-header/mobile-header.module.ts